<template>
  <div id="purchase-status-select" class="input-group">
    <select
      class="form-control"
      :name="selectName"
      id="purchase-status"
      v-on:change="emitChange"
      :multiple="multiple"
    >
      <option
        value="all"
        v-if="noFilter"
      >
        All Purchases (No Filter)
      </option>

      <option
        v-for="purchaseStatus in statuses"
        :selected="purchaseStatus == status"
        :value="purchaseStatus"
      >
        {{ displayStatus(purchaseStatus) }}
      </option>
    </select>
  </div>
</template>

<script>
import humanize from 'humanize-string'
import titleize from 'titleize'

import PurchaseMixin from '@/mixins/PurchaseMixin'

export default {
  mixins: [
    PurchaseMixin
  ],

  props: {
    noFilter: {
      type: String,
      default: undefined
    },

    multiple: {
      type: Boolean,
      default: false
    },

    selectName: {
      type: String,
      default: 'purchase[status][]'
    },

    status: {
      type: String,
      default: ''
    },

    requestedStatuses: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    emitChange (ev) {
      let opts = ev.target.selectedOptions

      let vals = []
      for (let i = 0; i < opts.length; i++) {
        vals.push(opts[i].value)
      }

      this.$parent.$emit('purchaseStatusChange', vals)
    },

    displayStatus (str) {
      return titleize(
        humanize(str)
      )
    }
  }
}
</script>

<style scoped>
#purchase-status[multiple=multiple] {
  height: 10rem;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseStatusSelect.vue